"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _hr = _interopRequireDefault(require("../../hr"));

var _topNav = require("../shared/top-nav.styles");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var MobileUserNavSection = function MobileUserNavSection(_ref) {
  var _ref$user = _ref.user,
      user = _ref$user === void 0 ? {} : _ref$user,
      _ref$userFetchState = _ref.userFetchState,
      userFetchState = _ref$userFetchState === void 0 ? 'pending' : _ref$userFetchState,
      _ref$routes = _ref.routes,
      routes = _ref$routes === void 0 ? [] : _ref$routes;
  var noUser = Object.keys(user).length === 0;
  var isPending = userFetchState === 'pending';
  var signedInRoutes = routes === null || routes === void 0 ? void 0 : routes.filter(function (route) {
    return (route === null || route === void 0 ? void 0 : route.type) === 'signed-in';
  });
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, noUser || isPending ? /*#__PURE__*/_react["default"].createElement("li", null, /*#__PURE__*/_react["default"].createElement(_topNav.NavLink, {
    isPending: isPending,
    href: "/login"
  }, "Sign In")) : /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, signedInRoutes === null || signedInRoutes === void 0 ? void 0 : signedInRoutes.map(function (route) {
    return /*#__PURE__*/_react["default"].createElement("li", {
      key: route === null || route === void 0 ? void 0 : route.url
    }, /*#__PURE__*/_react["default"].createElement(_topNav.NavLink, {
      href: route === null || route === void 0 ? void 0 : route.url
    }, route === null || route === void 0 ? void 0 : route.text), /*#__PURE__*/_react["default"].createElement(_hr["default"], null));
  })));
};

MobileUserNavSection.propTypes = {
  activeLink: _propTypes["default"].string,
  routes: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    icon: _propTypes["default"].string,
    text: _propTypes["default"].string,
    type: _propTypes["default"].string,
    url: _propTypes["default"].string
  })),
  user: _propTypes["default"].shape({}),
  userFetchState: _propTypes["default"].string
};
var _default = MobileUserNavSection;
exports["default"] = _default;